import React from 'react';
import { FormattedMessage } from 'react-intl';
import Tooltip from '../../../../../tooltip';
import { InternalApprovalApproversTooltipTable } from './InternalApprovalApproversTooltipTable';
import styles from './InternalApprovalBadge.module.scss';
import { InternalApprovalReview } from './RequestInternalApprovalModalConstants';

interface Props {
  documentId: string;
  dealId: string;
  teamId: string;
  requestId: string;
  isOneConfirmationRequired: boolean;
  approvalRequestedReviews?: InternalApprovalReview[];
  useApprovalOrder?: boolean;
  currentApproverId?: string;
  isCreator?: boolean;
}

export const approversCounter = ({
  approvedReviewsRequests,
  isOneConfirmationRequired,
  totalApprovalReviewRequests,
}: {
  approvedReviewsRequests: number;
  isOneConfirmationRequired: boolean;
  totalApprovalReviewRequests: number;
}) => (
  <span className={styles.internalApprovalBadgeContainer__approversCounter}>
    ({approvedReviewsRequests}/{isOneConfirmationRequired ? '1' : totalApprovalReviewRequests})
  </span>
);

export const InternalApprovalBadgeContainer = ({
  documentId: _documentId,
  dealId: _dealId,
  teamId: _teamId,
  requestId: _requestId,
  isOneConfirmationRequired,
  approvalRequestedReviews,
  useApprovalOrder,
  currentApproverId,
  isCreator,
}: Props) => {
  const internalApprovalPendingMessage = 'Internal Approval Pending';
  const totalApprovalReviewRequests = approvalRequestedReviews?.length || 0;
  const approvedReviewsRequests =
    approvalRequestedReviews?.filter((request: InternalApprovalReview) => !!request.approvedAt).length || 0;

  return (
    <>
      <div className={styles.internalApprovalBadgeContainer}>
        <span className="text-muted font-weight-bold">
          <FormattedMessage id="document-internal-approval.badge" defaultMessage={internalApprovalPendingMessage} />
        </span>
        <span className="pl-2">
          <Tooltip
            testId="internal-approvers-counter"
            icon={approversCounter({ approvedReviewsRequests, isOneConfirmationRequired, totalApprovalReviewRequests })}
            placement="bottom-end"
          >
            {isOneConfirmationRequired && <p className={styles.internalApprovalTooltipTitle}>1 Approval Required</p>}
            <InternalApprovalApproversTooltipTable
              approvalRequestedReviews={approvalRequestedReviews}
              useApprovalOrder={useApprovalOrder}
              currentApproverId={currentApproverId}
              isCreator={isCreator}
            />
          </Tooltip>
        </span>
      </div>
    </>
  );
};
